import React from 'react';
import { ErrorBoundaryContextProvider } from '@/presentation/providers/error-boundary-provider';
import { makeBreadcrumbsFromURLPath, } from "@/presentation/components/commons/breadcrumbs";
import { ProxiesHandlersProvider } from "@/presentation/providers";
import { Flashbar } from "@cloudscape-design/components-themed/components";
import { KiverascapeLayout } from '@/presentation/layouts/kiverascape-layout';
import ProxiesFormWrapper from "@/presentation/pages/proxies/proxies-form-wrapper";
import { useNotifications } from "@/presentation/providers/notifications-provider";
import { useLocation } from "react-router-dom";
const MakeProxiesWizard = (props) => {
    const location = useLocation();
    const breadCrumbs = makeBreadcrumbsFromURLPath(location === null || location === void 0 ? void 0 : location.pathname);
    const { notifications } = useNotifications();
    return (React.createElement(ErrorBoundaryContextProvider, null,
        React.createElement(KiverascapeLayout, { breadcrumbMenu: breadCrumbs, contentType: "form", notifications: React.createElement(Flashbar, { items: notifications, 
                // @ts-ignore
                stackItems: true }), content: React.createElement(React.Fragment, null,
                React.createElement(ProxiesHandlersProvider, null,
                    React.createElement(ProxiesFormWrapper, Object.assign({}, props)))) })));
};
export default MakeProxiesWizard;
